export const ANONYMOUS_ONLY_SEGMENT_ID = 'anonymousVisitorsOnly';

export const SIGNAL_TYPES = Object.freeze({
    RETENTION: 'retention',
    ADOPTION: 'adoption',
    VISITOR_ADOPTION: 'visitorAdoption',
    VISITOR_ENGAGEMENT: 'visitorEngagement',
    VISITOR_RAGE_CLICKS: 'visitorRageClicks',
    EVENT_ADOPTION: 'eventAdoption',
    VISITOR_RETENTION: 'visitorRetention',
    ACCOUNT_RETENTION: 'accountRetention',
});
